export default {
	data() {
		//linear-gradient(to right, #ff8a00, #e52d27)
		return {
			cellPaddingX: ['20rpx', '20rpx'],
			radiusX: '15rpx',
			radiusX2: '36rpx',
			radiusTopX: '15rpx 15rpx 0 0', //顶部圆角
			radiusBottomX: '0 0 15rpx 15rpx', //底部圆角
			paddingTopAndBottomX: ['20rpx', '0'], //用于多行输入框
			tbBackgroundColorX: 'linear-gradient(-180deg,#ff5000 0%,#ff6401 100%)',
			switchColorX: '#ff8a00', //开关颜色

			tobBarBackgroundColorX: 'linear-gradient(180deg, #8BC0B9, #B2CFBD)', //顶部导航背景颜色
			textSelectionColorX: '#ff8a00',

			loginPopup: false,
			loginShowView: false,


			xcBackgroundColor: 'linear-gradient(300deg,#fed6e3, #a8edea)',

			// #ifdef APP-PLUS
			IMG_HOST: '/static/app',
			// #endif
			// #ifndef APP-PLUS
			IMG_HOST: 'https://bf.img.ayiniao.com/uploads',
			ICON_HOST: 'https://bf.img.ayiniao.com/uploads',
			// #endif








		}
	},
	onLoad(option) {


	},
	methods: {},
	computed: {}
}